import City from "./components/city_app/cityapp";

export default function App() {
  return (
    <City />
  )
}

